import 'slick-carousel';
import 'jquery-ui-bundle';
import 'intl-tel-input/build/js/intlTelInput';
import Router from './util/Router';
import common from './routes/common';
import pageTemplateFrontPage from './routes/pageTemplateFrontPage';
import pageTemplateFrontPageV2 from './routes/pageTemplateFrontPageV2';
import pageTemplateFrontPageV4 from './routes/pageTemplateFrontPageV4';
import pageTemplatePageModules from './routes/pageTemplatePageModules';
import pageTemplateWhatWeAre from './routes/pageTemplateWhatWeAre';
import pageTemplateAccount from './routes/pageTemplateAccount';
import pageTemplateMembers from './routes/pageTemplateMembers';
import pageTemplateBooking from './routes/pageTemplateBooking';
import pageTemplateBenefits from './routes/pageTemplateBenefits';
import pageTemplateSingleBooking from './routes/pageTemplateSingleBooking';
import singleroom from './routes/singleroom';
import pageTemplateThirtyMinuteRooms from './routes/pageTemplateThirtyMinuteRooms';

import './styles/style.less';
import './styles/tailwind.less';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  pageTemplateFrontPage,
  pageTemplateFrontPageV2,
  pageTemplateFrontPageV4,
  pageTemplatePageModules,
  pageTemplateWhatWeAre,
  pageTemplateAccount,
  pageTemplateMembers,
  pageTemplateBooking,
  pageTemplateBenefits,
  pageTemplateSingleBooking,
  singleroom,
  pageTemplateThirtyMinuteRooms,
});


/** Load Events */
$(document).ready(() => routes.loadEvents());
